import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import {
  persistReducer,
  createTransform,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { reducer } from "./reducer";
import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import { resolveEndpoint } from "../Common/utils";

// Never persist endpoint — always derive from hostname / env on load
const endpointTransform = createTransform(
  (inboundState) => {
    if (!inboundState || typeof inboundState !== "object") {
      return inboundState;
    }
    const { endpoint, ...rest } = inboundState;
    return rest;
  },
  (outboundState) => {
    if (!outboundState || typeof outboundState !== "object") {
      return outboundState;
    }
    return {
      ...outboundState,
      endpoint: resolveEndpoint(),
    };
  },
  { whitelist: ["auth"] }
);

const persistConfig = {
  key: "Billing",
  storage,
  transforms: [endpointTransform],
};

const reducers = combineReducers({ auth: reducer });

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
